import React, { useContext, useEffect } from "react";
import { withRouter, useParams } from "react-router-dom";
import { SidebarLayout, ContentWrapper } from "../../../../../components/shared";
import { MainMenu } from "../../../../../components/entrepreneur/shared";
import { Breadcrumbs } from "../../../../../components/shared/odes/show";
import { MenuContext } from "../../../../../contexts/shared";
import { OdeDetail } from "../../../../../components/shared/odes/show";
import { useService } from "../../../../../hooks/shared";
import { OdesService } from "../../../../../services/odes-service";
import { CurrentUserContext } from "../../../../../contexts/shared";
import { EditCompanyProvider } from "../../../../../contexts/shared/edit-company";
import { cloneDeep } from "lodash";

function GeneralInformationIndex() {
  const { id: odeId } = useParams();

  const { loading, data, refetch = {} } = useService(
    OdesService.getById,
    { id: odeId });

  const { setMenuState } = useContext(MenuContext);
  const { currentUser } = useContext(CurrentUserContext);

  useEffect(() => {
    setMenuState({
      openKeys: ["odes"],
      selectedKeys: ["odes"]
    });
  }, []);

  const allowEdit = currentUser.odes.some(userOde => userOde.id === odeId);

  return (
    <EditCompanyProvider data={data ? cloneDeep(data) : null} refetch={refetch}>
      <SidebarLayout menu={<MainMenu />}>
        <Breadcrumbs
          odeName={data?.name} />
        <ContentWrapper>
          <OdeDetail
            companyId={odeId}
            allowEdit={allowEdit}
            data={data}
            loading={loading}
            refetch={refetch} />
        </ContentWrapper>
      </SidebarLayout>
    </EditCompanyProvider>
  );
}

export default withRouter(GeneralInformationIndex);
